import {
  THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS,
  THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_SUCCESS,
  THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_FAILURE,
  THIRD_PARTY_GPSLIVE_CHECK_STATUS,
  THIRD_PARTY_GPSLIVE_CHECK_STATUS_SUCCESS,
  THIRD_PARTY_GPSLIVE_CHECK_STATUS_FAILURE,
  THIRD_PARTY_GPSLIVE_TEST_CONNECTION,
  THIRD_PARTY_GPSLIVE_TEST_CONNECTION_SUCCESS,
  THIRD_PARTY_GPSLIVE_TEST_CONNECTION_FAILURE,
  THIRD_PARTY_GPSLIVE_UNASSIGN,
  THIRD_PARTY_GPSLIVE_UNASSIGN_SUCCESS,
  THIRD_PARTY_GPSLIVE_UNASSIGN_FAILURE,
  THIRD_PARTY_VAPI_LIST,
  THIRD_PARTY_VAPI_LIST_SUCCESS,
  THIRD_PARTY_VAPI_LIST_FAILURE,
  THIRD_PARTY_VAPI_DATA,
  THIRD_PARTY_VAPI_DATA_SUCCESS,
  THIRD_PARTY_VAPI_DATA_FAILURE,
  THIRD_PARTY_VAPI_CREATE,
  THIRD_PARTY_VAPI_CREATE_SUCCESS,
  THIRD_PARTY_VAPI_CREATE_FAILURE,
  THIRD_PARTY_VAPI_UPDATE,
  THIRD_PARTY_VAPI_UPDATE_SUCCESS,
  THIRD_PARTY_VAPI_UPDATE_FAILURE,
  THIRD_PARTY_VAPI_DELETE,
  THIRD_PARTY_VAPI_DELETE_SUCCESS,
  THIRD_PARTY_VAPI_DELETE_FAILURE,
  THIRD_PARTY_VAPI_PROVISION,
  THIRD_PARTY_VAPI_PROVISION_SUCCESS,
  THIRD_PARTY_VAPI_PROVISION_FAILURE,
  THIRD_PARTY_VAPI_LINK_TWILIO,
  THIRD_PARTY_VAPI_LINK_TWILIO_SUCCESS,
  THIRD_PARTY_VAPI_LINK_TWILIO_FAILURE,
  THIRD_PARTY_VAPI_TOGGLE,
  THIRD_PARTY_VAPI_TOGGLE_SUCCESS,
  THIRD_PARTY_VAPI_TOGGLE_FAILURE,
  CALL_PROVIDER_LIST,
  CALL_PROVIDER_LIST_SUCCESS,
  CALL_PROVIDER_LIST_FAILURE,
  TELEPHONE_NUMBER_AVAILABLE,
  TELEPHONE_NUMBER_AVAILABLE_SUCCESS,
  TELEPHONE_NUMBER_AVAILABLE_FAILURE,
  TELEPHONE_NUMBER_PURCHASE,
  TELEPHONE_NUMBER_PURCHASE_SUCCESS,
  TELEPHONE_NUMBER_PURCHASE_FAILURE,
  TELEPHONE_NUMBER_LIST,
  TELEPHONE_NUMBER_LIST_SUCCESS,
  TELEPHONE_NUMBER_LIST_FAILURE,
  THIRD_PARTY_XERO_URL_AUTH,
  THIRD_PARTY_XERO_URL_AUTH_SUCCESS,
  THIRD_PARTY_XERO_URL_AUTH_FAILURE,
  THIRD_PARTY_XERO_CHECK_STATUS,
  THIRD_PARTY_XERO_CHECK_STATUS_SUCCESS,
  THIRD_PARTY_XERO_CHECK_STATUS_FAILURE,
  THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN,
  THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_SUCCESS,
  THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_FAILURE,
  THIRD_PARTY_XERO_ASSIGN_TENANT,
  THIRD_PARTY_XERO_ASSIGN_TENANT_SUCCESS,
  THIRD_PARTY_XERO_ASSIGN_TENANT_FAILURE,
  THIRD_PARTY_XERO_SYNC_MANUAL,
  THIRD_PARTY_XERO_SYNC_MANUAL_SUCCESS,
  THIRD_PARTY_XERO_SYNC_MANUAL_FAILURE,
  THIRD_PARTY_XERO_UNASSIGN_TENANT,
  THIRD_PARTY_XERO_UNASSIGN_TENANT_SUCCESS,
  THIRD_PARTY_XERO_UNASSIGN_TENANT_FAILURE,
  THIRD_PARTY_GOOGLE_URL_AUTH,
  THIRD_PARTY_GOOGLE_URL_AUTH_SUCCESS,
  THIRD_PARTY_GOOGLE_URL_AUTH_FAILURE,
  THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN,
  THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_SUCCESS,
  THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_FAILURE,
  THIRD_PARTY_HMRC_URL_AUTH,
  THIRD_PARTY_HMRC_URL_AUTH_SUCCESS,
  THIRD_PARTY_HMRC_URL_AUTH_FAILURE,
  THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS,
  THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_FAILURE,
  THIRD_PARTY_BRIGHTPAY_URL_AUTH,
  THIRD_PARTY_BRIGHTPAY_URL_AUTH_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_URL_AUTH_FAILURE,
  THIRD_PARTY_BRIGHTPAY_CHECK_STATUS,
  THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_FAILURE,
  THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN,
  THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_FAILURE,
  THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER,
  THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_FAILURE,
  THIRD_PARTY_BRIGHTPAY_UNASSIGN,
  THIRD_PARTY_BRIGHTPAY_UNASSIGN_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_UNASSIGN_FAILURE,
  THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES,
  THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_FAILURE,
  THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST,
  THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_SUCCESS,
  THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_FAILURE,
} from "./actionType";

//THIRD_PARTY_XERO_URL_AUTH
export const thirdPartyXeroUrlAuth = () => ({
  type: THIRD_PARTY_XERO_URL_AUTH,
});

export const thirdPartyXeroUrlAuthSuccess = (payload) => ({
  type: THIRD_PARTY_XERO_URL_AUTH_SUCCESS,
  payload,
});

export const thirdPartyXeroUrlAuthFailure = (payload) => ({
  type: THIRD_PARTY_XERO_URL_AUTH_FAILURE,
  payload,
});

//THIRD_PARTY_XERO_CHECK_STATUS
export const thirdPartyXeroCheckStatus = () => ({
  type: THIRD_PARTY_XERO_CHECK_STATUS,
});

export const thirdPartyXeroCheckStatusSuccess = (payload) => ({
  type: THIRD_PARTY_XERO_CHECK_STATUS_SUCCESS,
  payload,
});

export const thirdPartyXeroCheckStatusFailure = (payload) => ({
  type: THIRD_PARTY_XERO_CHECK_STATUS_FAILURE,
  payload,
});

//THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN
export const thirdPartyXeroGenerateAccessToken = (payload) => ({
  type: THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN,
  payload,
});

export const thirdPartyXeroGenerateAccessTokenSuccess = (payload) => ({
  type: THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_SUCCESS,
  payload,
});

export const thirdPartyXeroGenerateAccessTokenFailure = (payload) => ({
  type: THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN_FAILURE,
  payload,
});

//THIRD_PARTY_XERO_ASSIGN_TENANT
export const thirdPartyXeroAssignTenant = (payload) => ({
  type: THIRD_PARTY_XERO_ASSIGN_TENANT,
  payload,
});

export const thirdPartyXeroAssignTenantSuccess = (payload) => ({
  type: THIRD_PARTY_XERO_ASSIGN_TENANT_SUCCESS,
  payload,
});

export const thirdPartyXeroAssignTenantFailure = (payload) => ({
  type: THIRD_PARTY_XERO_ASSIGN_TENANT_FAILURE,
  payload,
});

//THIRD_PARTY_XERO_SYNC_MANUAL
export const thirdPartyXeroSyncManual = () => ({
  type: THIRD_PARTY_XERO_SYNC_MANUAL,
});

export const thirdPartyXeroSyncManualSuccess = (payload) => ({
  type: THIRD_PARTY_XERO_SYNC_MANUAL_SUCCESS,
  payload,
});

export const thirdPartyXeroSyncManualFailure = (payload) => ({
  type: THIRD_PARTY_XERO_SYNC_MANUAL_FAILURE,
  payload,
});

//THIRD_PARTY_XERO_UNASSIGN_TENANT
export const thirdPartyXeroUnassignTenant = () => ({
  type: THIRD_PARTY_XERO_UNASSIGN_TENANT,
});

export const thirdPartyXeroUnassignTenantSuccess = (payload) => ({
  type: THIRD_PARTY_XERO_UNASSIGN_TENANT_SUCCESS,
  payload,
});

export const thirdPartyXeroUnassignTenantFailure = (payload) => ({
  type: THIRD_PARTY_XERO_UNASSIGN_TENANT_FAILURE,
  payload,
});

//THIRD_PARTY_GOOGLE_URL_AUTH
export const thirdPartyGoogleUrlAuth = () => ({
  type: THIRD_PARTY_GOOGLE_URL_AUTH,
});
export const thirdPartyGoogleUrlAuthSuccess = (payload) => ({
  type: THIRD_PARTY_GOOGLE_URL_AUTH_SUCCESS,
  payload,
});
export const thirdPartyGoogleUrlAuthFailure = (payload) => ({
  type: THIRD_PARTY_GOOGLE_URL_AUTH_FAILURE,
  payload,
});
//THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN
export const thirdPartyGoogleGenerateAccessToken = (payload) => ({
  type: THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN,
  payload,
});
export const thirdPartyGoogleGenerateAccessTokenSuccess = (payload) => ({
  type: THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_SUCCESS,
  payload,
});
export const thirdPartyGoogleGenerateAccessTokenFailure = (payload) => ({
  type: THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN_FAILURE,
  payload,
});

//THIRD_PARTY_HMRC_URL_AUTH
export const thirdPartyHmrcUrlAuth = () => ({
  type: THIRD_PARTY_HMRC_URL_AUTH,
});

export const thirdPartyHmrcUrlAuthSuccess = (payload) => ({
  type: THIRD_PARTY_HMRC_URL_AUTH_SUCCESS,
  payload,
});

export const thirdPartyHmrcUrlAuthFailure = (payload) => ({
  type: THIRD_PARTY_HMRC_URL_AUTH_FAILURE,
  payload,
});

//THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS
export const thirdPartyBrightPaySaveCredentials = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS,
  payload,
});
export const thirdPartyBrightPaySaveCredentialsSuccess = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_SUCCESS,
  payload,
});
export const thirdPartyBrightPaySaveCredentialsFailure = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS_FAILURE,
  payload,
});

//THIRD_PARTY_BRIGHTPAY_URL_AUTH
export const thirdPartyBrightPayUrlAuth = () => ({
  type: THIRD_PARTY_BRIGHTPAY_URL_AUTH,
});
export const thirdPartyBrightPayUrlAuthSuccess = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_URL_AUTH_SUCCESS,
  payload,
});
export const thirdPartyBrightPayUrlAuthFailure = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_URL_AUTH_FAILURE,
  payload,
});

//THIRD_PARTY_BRIGHTPAY_CHECK_STATUS
export const thirdPartyBrightPayCheckStatus = () => ({
  type: THIRD_PARTY_BRIGHTPAY_CHECK_STATUS,
});
export const thirdPartyBrightPayCheckStatusSuccess = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_SUCCESS,
  payload,
});
export const thirdPartyBrightPayCheckStatusFailure = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_CHECK_STATUS_FAILURE,
  payload,
});

//THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN
export const thirdPartyBrightPayGenerateAccessToken = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN,
  payload,
});
export const thirdPartyBrightPayGenerateAccessTokenSuccess = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_SUCCESS,
  payload,
});
export const thirdPartyBrightPayGenerateAccessTokenFailure = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN_FAILURE,
  payload,
});

//THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER
export const thirdPartyBrightPayAssignEmployer = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER,
  payload,
});
export const thirdPartyBrightPayAssignEmployerSuccess = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_SUCCESS,
  payload,
});
export const thirdPartyBrightPayAssignEmployerFailure = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER_FAILURE,
  payload,
});

//THIRD_PARTY_BRIGHTPAY_UNASSIGN
export const thirdPartyBrightPayUnassign = () => ({
  type: THIRD_PARTY_BRIGHTPAY_UNASSIGN,
});
export const thirdPartyBrightPayUnassignSuccess = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_UNASSIGN_SUCCESS,
  payload,
});
export const thirdPartyBrightPayUnassignFailure = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_UNASSIGN_FAILURE,
  payload,
});

//THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES
export const thirdPartyBrightPaySyncEmployees = () => ({
  type: THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES,
});
export const thirdPartyBrightPaySyncEmployeesSuccess = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_SUCCESS,
  payload,
});
export const thirdPartyBrightPaySyncEmployeesFailure = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES_FAILURE,
  payload,
});

//THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST
export const thirdPartyBrightPayEmployeeList = () => ({
  type: THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST,
});
export const thirdPartyBrightPayEmployeeListSuccess = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_SUCCESS,
  payload,
});
export const thirdPartyBrightPayEmployeeListFailure = (payload) => ({
  type: THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST_FAILURE,
  payload,
});

//THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS
export const thirdPartyGpsLiveSaveCredentials = (payload) => ({
  type: THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS,
  payload,
});
export const thirdPartyGpsLiveSaveCredentialsSuccess = (payload) => ({
  type: THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_SUCCESS,
  payload,
});
export const thirdPartyGpsLiveSaveCredentialsFailure = (payload) => ({
  type: THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS_FAILURE,
  payload,
});

//THIRD_PARTY_GPSLIVE_CHECK_STATUS
export const thirdPartyGpsLiveCheckStatus = () => ({
  type: THIRD_PARTY_GPSLIVE_CHECK_STATUS,
});
export const thirdPartyGpsLiveCheckStatusSuccess = (payload) => ({
  type: THIRD_PARTY_GPSLIVE_CHECK_STATUS_SUCCESS,
  payload,
});
export const thirdPartyGpsLiveCheckStatusFailure = (payload) => ({
  type: THIRD_PARTY_GPSLIVE_CHECK_STATUS_FAILURE,
  payload,
});

//THIRD_PARTY_GPSLIVE_TEST_CONNECTION
export const thirdPartyGpsLiveTestConnection = () => ({
  type: THIRD_PARTY_GPSLIVE_TEST_CONNECTION,
});
export const thirdPartyGpsLiveTestConnectionSuccess = (payload) => ({
  type: THIRD_PARTY_GPSLIVE_TEST_CONNECTION_SUCCESS,
  payload,
});
export const thirdPartyGpsLiveTestConnectionFailure = (payload) => ({
  type: THIRD_PARTY_GPSLIVE_TEST_CONNECTION_FAILURE,
  payload,
});

//THIRD_PARTY_GPSLIVE_UNASSIGN
export const thirdPartyGpsLiveUnassign = () => ({
  type: THIRD_PARTY_GPSLIVE_UNASSIGN,
});
export const thirdPartyGpsLiveUnassignSuccess = (payload) => ({
  type: THIRD_PARTY_GPSLIVE_UNASSIGN_SUCCESS,
  payload,
});
export const thirdPartyGpsLiveUnassignFailure = (payload) => ({
  type: THIRD_PARTY_GPSLIVE_UNASSIGN_FAILURE,
  payload,
});

//THIRD_PARTY_VAPI_LIST
export const thirdPartyVapiList = () => ({
  type: THIRD_PARTY_VAPI_LIST,
});
export const thirdPartyVapiListSuccess = (payload) => ({
  type: THIRD_PARTY_VAPI_LIST_SUCCESS,
  payload,
});
export const thirdPartyVapiListFailure = (payload) => ({
  type: THIRD_PARTY_VAPI_LIST_FAILURE,
  payload,
});

//THIRD_PARTY_VAPI_DATA
export const thirdPartyVapiData = (payload) => ({
  type: THIRD_PARTY_VAPI_DATA,
  payload,
});
export const thirdPartyVapiDataSuccess = (payload) => ({
  type: THIRD_PARTY_VAPI_DATA_SUCCESS,
  payload,
});
export const thirdPartyVapiDataFailure = (payload) => ({
  type: THIRD_PARTY_VAPI_DATA_FAILURE,
  payload,
});

//THIRD_PARTY_VAPI_CREATE
export const thirdPartyVapiCreate = (payload) => ({
  type: THIRD_PARTY_VAPI_CREATE,
  payload,
});
export const thirdPartyVapiCreateSuccess = (payload) => ({
  type: THIRD_PARTY_VAPI_CREATE_SUCCESS,
  payload,
});
export const thirdPartyVapiCreateFailure = (payload) => ({
  type: THIRD_PARTY_VAPI_CREATE_FAILURE,
  payload,
});

//THIRD_PARTY_VAPI_UPDATE
export const thirdPartyVapiUpdate = (payload) => ({
  type: THIRD_PARTY_VAPI_UPDATE,
  payload,
});
export const thirdPartyVapiUpdateSuccess = (payload) => ({
  type: THIRD_PARTY_VAPI_UPDATE_SUCCESS,
  payload,
});
export const thirdPartyVapiUpdateFailure = (payload) => ({
  type: THIRD_PARTY_VAPI_UPDATE_FAILURE,
  payload,
});

//THIRD_PARTY_VAPI_DELETE
export const thirdPartyVapiDelete = (payload) => ({
  type: THIRD_PARTY_VAPI_DELETE,
  payload,
});
export const thirdPartyVapiDeleteSuccess = (payload) => ({
  type: THIRD_PARTY_VAPI_DELETE_SUCCESS,
  payload,
});
export const thirdPartyVapiDeleteFailure = (payload) => ({
  type: THIRD_PARTY_VAPI_DELETE_FAILURE,
  payload,
});

//THIRD_PARTY_VAPI_PROVISION
export const thirdPartyVapiProvision = (payload) => ({
  type: THIRD_PARTY_VAPI_PROVISION,
  payload,
});
export const thirdPartyVapiProvisionSuccess = (payload) => ({
  type: THIRD_PARTY_VAPI_PROVISION_SUCCESS,
  payload,
});
export const thirdPartyVapiProvisionFailure = (payload) => ({
  type: THIRD_PARTY_VAPI_PROVISION_FAILURE,
  payload,
});

//THIRD_PARTY_VAPI_LINK_TWILIO
export const thirdPartyVapiLinkTwilio = (payload) => ({
  type: THIRD_PARTY_VAPI_LINK_TWILIO,
  payload,
});
export const thirdPartyVapiLinkTwilioSuccess = (payload) => ({
  type: THIRD_PARTY_VAPI_LINK_TWILIO_SUCCESS,
  payload,
});
export const thirdPartyVapiLinkTwilioFailure = (payload) => ({
  type: THIRD_PARTY_VAPI_LINK_TWILIO_FAILURE,
  payload,
});

//THIRD_PARTY_VAPI_TOGGLE
export const thirdPartyVapiToggle = (payload) => ({
  type: THIRD_PARTY_VAPI_TOGGLE,
  payload,
});
export const thirdPartyVapiToggleSuccess = (payload) => ({
  type: THIRD_PARTY_VAPI_TOGGLE_SUCCESS,
  payload,
});
export const thirdPartyVapiToggleFailure = (payload) => ({
  type: THIRD_PARTY_VAPI_TOGGLE_FAILURE,
  payload,
});

//CALL_PROVIDER_LIST
export const callProviderList = () => ({
  type: CALL_PROVIDER_LIST,
});
export const callProviderListSuccess = (payload) => ({
  type: CALL_PROVIDER_LIST_SUCCESS,
  payload,
});
export const callProviderListFailure = (payload) => ({
  type: CALL_PROVIDER_LIST_FAILURE,
  payload,
});

//TELEPHONE_NUMBER_AVAILABLE
export const telephoneNumberAvailable = (payload) => ({
  type: TELEPHONE_NUMBER_AVAILABLE,
  payload,
});
export const telephoneNumberAvailableSuccess = (payload) => ({
  type: TELEPHONE_NUMBER_AVAILABLE_SUCCESS,
  payload,
});
export const telephoneNumberAvailableFailure = (payload) => ({
  type: TELEPHONE_NUMBER_AVAILABLE_FAILURE,
  payload,
});

//TELEPHONE_NUMBER_PURCHASE
export const telephoneNumberPurchase = (payload) => ({
  type: TELEPHONE_NUMBER_PURCHASE,
  payload,
});
export const telephoneNumberPurchaseSuccess = (payload) => ({
  type: TELEPHONE_NUMBER_PURCHASE_SUCCESS,
  payload,
});
export const telephoneNumberPurchaseFailure = (payload) => ({
  type: TELEPHONE_NUMBER_PURCHASE_FAILURE,
  payload,
});

//TELEPHONE_NUMBER_LIST
export const telephoneNumberList = () => ({
  type: TELEPHONE_NUMBER_LIST,
});
export const telephoneNumberListSuccess = (payload) => ({
  type: TELEPHONE_NUMBER_LIST_SUCCESS,
  payload,
});
export const telephoneNumberListFailure = (payload) => ({
  type: TELEPHONE_NUMBER_LIST_FAILURE,
  payload,
});
